import React, { Component } from 'react';
import $ from 'jquery';

//import Partnerlayout from './Partnerlayout';
import AdminLayout from './layout';
import { getUserInfo } from '../../API/FetchCall';

import loadinggif from '../../../src/assets/bewiseloading.gif';

import {
  getLeadsByPartner,
  getVendorInfo,
  approveVendorInfo,
  approveVendorInfoCurated,
  rejectVendorInfo,
  commonAPI, adminUser,
  indResponse,
  getPayLink,
  userExport,
  sendMailPayLink,
  partnerSubscription,
  getPlan,
  getDiscountNew,
  savePayLink,
  creatediscount,
  checkDiscountInfo
} from "../../API/FetchCall";
 

class parentDetail extends Component {

     constructor(props) {
        super(props);
        this.state = {
            user_id: this.props.match.params.id,
            child_data: []
        }
    }
    componentDidMount() {

        let userinfo = JSON.stringify({
            user_id: this.state.user_id,
        });
        
        getUserInfo(userinfo).then((response) => {
            if (response.status == 1) {
                let data = response.results[0];
                this.setState({
                    first_name: data.first_name,
                    last_name: data.last_name,
                    email_id: data.email_id,
                    mobile_no: data.mobile_no,
                    child_name: data.child_name,
                    age: data.child_age,
                    user_type: data.login_type,
                    child_data: data.child_data,
                });
            } else {
                console.log(response.status)
            }
        });
    }
    UNSAFE_componentWillMount() {

    }
    componentDidUpdate() {
        
    }

    render() {
     
        return (
            <React.Fragment>


                  <AdminLayout>

                  <div class="row">
                    <div class="col-md-12">

                        <div className="content-top col-md-12 col-xs-12">
                        <h3>Partner Info</h3>
                        </div>
            
                    <div className="col-md-12 col-xs-12">
                 
                  <div className="partnerinfoclass">
                     <div id="company-info" className="tab-pane active">
                                            <form className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no">
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="form-group col-md-4">
                                                            <label>First Name</label>
                                                            <p className="p14">{this.state.first_name}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Last Name</label>
                                                            <p className="p14">{this.state.last_name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="form-group col-md-4">
                                                            <label>Email Id</label>
                                                            <p className="p14"><a mailto="#">{this.state.email_id}</a></p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Mobile Number</label>
                                                            <p className="p14">{this.state.mobile_no}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="form-group col-md-12">
                                                            <label>Child Details</label>
                                                            <table className='table'>
                                                                <thead>
                                                                    <tr>
                                                                        <td>Name</td>
                                                                        <td>Age</td>
                                                                        <td>City</td>
                                                                        <td>School</td>
                                                                    </tr>
                                                                </thead>
                                                                <thead>
                                                                    {this.state.child_data.map((items, i) => {
                                                                        return (
                                                                            <tr>
                                                                                <td>{items.child_name ? items.child_name : '-'}</td>
                                                                                <td>{items.child_age ? items.child_age : '-'}</td>
                                                                                <td>{items.child_city ? items.child_city : '-'}</td>
                                                                                <td>{items.child_scl ? items.child_scl : '-'}</td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                                </thead>
                                                            </table>
                                                        </div>
                                                    </div>

                                                </div>
                                            </form>
                                        </div>
                  </div>
                </div>
               

                </div>
                    </div>

                </AdminLayout>
            </React.Fragment>
        )
    }


 

}


export default parentDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/parentDetail.jsx